import React, { Component } from 'react';

export default class SearchError extends Component
{
	render()
	{
		return (
			<h3 className="text-muted font-weight-light text-center" style={{ marginTop: '100px' }}>No Results Found</h3>
		);
	}
}
